// extracted by mini-css-extract-plugin
module.exports = {"applyMargin":"BaseFilterDropdown_applyMargin_cqENv","dropdownItem":"BaseFilterDropdown_dropdownItem_T-5GI","spinAround":"BaseFilterDropdown_spinAround_6EJwo"};